export const addFormImg = {
    src: 'https://res.cloudinary.com/perfit/image/upload/v1661439827/arthur-mazi-a8CxRWIu8yw-unsplash-e1651170357711-810x522_apooep.jpg',
    alt: 'Blue sky and rooftop'
};

export const editFormImg = {
    src: 'https://w0.peakpx.com/wallpaper/281/219/HD-wallpaper-helicopter-sky-cloud-flight.jpg',
    alt: 'Blue sky and helicopter'
};

export const signUpFormImg = {
    src: 'https://res.cloudinary.com/perfit/image/upload/a_vflip/a_180/v1661439109/_DSC2505_rcjgx9.jpg',
    alt: 'Glass paned house in front of deep blue sky'
};